__turbopack_context__.v({
  "marqueeContainer": "VerticalMarquee-module__f6P_ga__marqueeContainer",
  "marqueeContent": "VerticalMarquee-module__f6P_ga__marqueeContent",
  "marqueeItem": "VerticalMarquee-module__f6P_ga__marqueeItem",
  "scrollUp": "VerticalMarquee-module__f6P_ga__scrollUp",
});
